import {useQuery} from "@tanstack/react-query";
import {getHeadbandService} from "../../services/games/gamesList/headband.service";
import {useAuthStore} from "../../store/useAuth.store";
import {isVisibleGame} from "../../util/hiddenGames";

const ONE_HOUR = 1000 * 60 * 60;

export const useGetBigWinners = () => {
  const authStatus = useAuthStore(state => state.authStatus);
  const {data, isPending, isFetching} = useQuery({
    queryKey: ["bigWinners", authStatus],
    queryFn: () => getHeadbandService(),
    staleTime: ONE_HOUR,
    gcTime: ONE_HOUR,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    retry: false,
  });
  const winners = (data?.data?.data?.winners || []).filter(isVisibleGame);
  return {
    data,
    isPending,
    isFetching,
    winners,
  };
};
